// src/App.tsx

import React, { Suspense, lazy } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Layout from "./components/Layout/Layout";
import LoadingSpinner from "./components/LoadingSpinner/LoadingSpinner";
import { TitleProvider } from "./contexts/TitleContext/TitleContext";
import PageWithTitle from "./components/PageWithTitle/PageWithTitle";
import { useTranslation } from "react-i18next";
import "./i18n/i18n"; // Import i18n configuration
import "./styles/global.scss";

// Lazy loading stron:
const Home = lazy(() => import("./pages/Home"));
const TournamentsMap = lazy(() => import("./pages/TournamentsMap"));
const AddTournament = lazy(() => import("./pages/AddTournament"));
const NotFoundPage = lazy(() => import("./pages/NotFoundPage"));
const ImportTournaments = lazy(() => import("./pages/ImportTournaments"));

const App: React.FC = () => {
    const { t } = useTranslation();

    return (
        <TitleProvider>
            <Router>
                <Layout>
                    <Suspense fallback={<LoadingSpinner />}>
                        <Routes>
                            <Route
                                path="/"
                                element={<PageWithTitle title={t("navigation.home")} element={<Home />} />}
                            />
                            <Route
                                path="/turnieje"
                                element={
                                    <PageWithTitle title={t("navigation.tournaments")} element={<TournamentsMap />} />
                                }
                            />
                            <Route
                                path="/dodaj"
                                element={
                                    <PageWithTitle title={t("navigation.addTournament")} element={<AddTournament />} />
                                }
                            />
                            <Route
                                path="/import"
                                element={
                                    <PageWithTitle title={t("navigation.import")} element={<ImportTournaments />} />
                                }
                            />
                            <Route
                                path="*"
                                element={<PageWithTitle title={t("notFound.title")} element={<NotFoundPage />} />}
                            />
                        </Routes>
                    </Suspense>
                </Layout>
            </Router>
        </TitleProvider>
    );
};

export default App;
